import { Navigate } from 'react-router-dom';
import ProtectedRoute from '@/app/router/ProtectedRoute';
import AdminLayout from '@/app/layouts/AdminLayout';

import { dashboardRoutes } from '@/features/admin/dashboard/dashboard.routes';
import { roleRoutes } from '@/features/admin/roles-permissions/roles.routes';
import { quoteRequestsRoutes } from '@/features/admin/quote-requests/quoteRequest.routes';
import { settingsRoutes } from '@/features/admin/settings/settings.routes';

import { routeItem } from '@/types';

const applyAccessControl = (routes: routeItem[]) =>
  routes.map((route) => ({
    ...route,
    element:

      route.roles || route.permission ? (
        <ProtectedRoute
          requiredRoles={route.roles}
          requiredPermission={route.permission}
        >
          {route.element}
        </ProtectedRoute>
      ) : (
        <ProtectedRoute>
          {route.element}
        </ProtectedRoute>
      ),
  }));
const featureRoutes = applyAccessControl([
  ...dashboardRoutes,
  ...roleRoutes,
  ...quoteRequestsRoutes,
  ...settingsRoutes
]);

export const adminRoutes = [
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      ...featureRoutes,
    ]
  },
];